import { RoleDTO } from '../../submodules/roles/api/roles.contracts';

export enum UserType {
  GUEST = 'GUEST',
  OPERATOR = 'OPERATOR',
}

export class UserLocationDTO {
  id: number;
  userId: number;
  locationId: number;
  locationName?: string; // Optional, for when we want to include location details
  locationCode?: string; // Optional, for when we want to include location code

  constructor(id: number, userId: number, locationId: number, locationName?: string, locationCode?: string) {
    this.id = id;
    this.userId = userId;
    this.locationId = locationId;
    this.locationName = locationName;
    this.locationCode = locationCode;
  }
}

export interface UserDTO {
  id: number;
  firebaseId: string;
  name: string;
  email: string;
  password: string;
  type: UserType;
  isActive: boolean;
  roles: RoleDTO[];
  userLocations?: UserLocationDTO[];
}
export interface UserCreateDTO {
  name: string;
  email: string;
  password: string;
  type?: UserType;
  isActive?: boolean;
  roleIds: number[];
  locationIds?: number[];
}

export interface UserUpdateDTO {
  name: string;
  password?: string;
  type?: UserType;
  isActive?: boolean;
  roleIds: number[];
  locationIds?: number[];
}
